import { isMobilePage } from 'lib/util/helpers';

export default class NodeWrapper {
	protected $ctx : JQuery;
	private children : NodeWrapper[];
	private _parent! : NodeWrapper;

	constructor($ctx : JQuery) {
		this.$ctx = $ctx;
		this.children = [];
	}

	set parent(parent : NodeWrapper) {
		this._parent = parent;
	}

	get parent() {
		return this._parent;
	}

	public getContext() {
		return this.$ctx;
	}

	public updateState(current : boolean | null, active : boolean | null) {
		if (current !== null) {
			this.$ctx.toggleClass('current', current);
			if (isMobilePage() && this.$ctx.hasClass('topic')) {
				this.$ctx[0].setAttribute('aria-hidden', String(!current));
			}
			if (current) {
				active = true;
			}
		}

		if (active !== null) {
			this.$ctx.toggleClass('active', active);
		}
	}

	public addChild(child : NodeWrapper) {
		this.children.push(child);
	}

	public getChildren() {
		return this.children;
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/NodeWrapper.ts